<template>
  <div class="go-abroad" :style="{ backgroundColor: bgColor }">
    <div class="content">
      <div class="title">
        <slot name="header"></slot>
      </div>
      <div class="course-list">
        <img
          v-for="(item, index) in imgList"
          :key="index"
          :src="item"
          alt=""
          srcset=""
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    bgColor: {
      type: String,
      default: '#fff',
    },
  },
  data() {
    return {
      imgList: [
        require('../../assets/img/America.png'),
        require('../../assets/img/Germany.png'),
        require('../../assets/img/jianada.png'),
        require('../../assets/img/Finland.png'),
        require('../../assets/img/Australia.png'),
        require('../../assets/img/Singapore.png'),
        require('../../assets/img/Saudi.png'),
        require('../../assets/img/Japan.png'),
      ],
    }
  },
}
</script>
<style lang="less" scoped>
.go-abroad {
  // display: flex;
  // justify-content: center;
  text-align: center;
  padding: 100px 0;
  .content {
    display: inline-block;
    width: 1280px;
    .title {
      display: flex;
      justify-content: center;
      margin-bottom: 60px;
    }
    .course-list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      img {
        width: 140px;
        height: 172px;
        border-radius: 12px;
      }
    }
  }
}
</style>
